/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic
 *
 * The version of the OpenAPI document: 0.1.1
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WatchdogEventWatchdog
 */
export interface WatchdogEventWatchdog {
    /**
     * 
     * @type {number}
     * @memberof WatchdogEventWatchdog
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WatchdogEventWatchdog
     */
    name?: string;
}

/**
 * Check if a given object implements the WatchdogEventWatchdog interface.
 */
export function instanceOfWatchdogEventWatchdog(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WatchdogEventWatchdogFromJSON(json: any): WatchdogEventWatchdog {
    return WatchdogEventWatchdogFromJSONTyped(json, false);
}

export function WatchdogEventWatchdogFromJSONTyped(json: any, ignoreDiscriminator: boolean): WatchdogEventWatchdog {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function WatchdogEventWatchdogToJSON(value?: WatchdogEventWatchdog | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

